import { useQuery } from "@tanstack/react-query";
import useAPI from "../../../../api/hooks/useAPI";
import { rdsEntitiesKeys } from "../../../../api/queryKeys";
import { useEntities } from "./useEntities";

export default function useRdsEntityById({ entityId, customerId, enabled }) {
  const { fetchEntityByIdRds } = useAPI();
  const { flattenEntity } = useEntities();

  return useQuery({
    queryKey: rdsEntitiesKeys.entity(customerId, entityId),
    queryFn: () => fetchEntityByIdRds(entityId, customerId),
    enabled: Boolean(enabled),
    select: (response) => {
      if (!response?.data) return null;
      return flattenEntity(response.data);
    },
  });
}
